import { FloraButton, Card, Flex, Grid, styled } from '@grupoboticario/flora-react';

import { Skeleton } from 'components';

const styles = {
  ButtonLoadMore: styled(FloraButton, {
    marginBottom: '$6',
  }),

  Card: styled(Card, {
    overflow: 'hidden',
  }),

  CarrouselsWrapper: styled(Flex, {
    margin: '$6 0',
  }),

  SkeletonWrapper: styled(Flex, {
    alignItems: 'center',
    gap: '$4',
    marginTop: '$6',
    padding: '$0',
  }),

  SkeletonImage: styled(Skeleton, {
    height: '40vh',
    width: '100%',
  }),

  ListImagesWrapper: styled(Grid, {
    gap: '$4',

    '@tablet': {
      gridTemplateColumns: 'repeat(auto-fill, minmax(calc($22 * 3), 1fr))',
    },
  }),

  SectionWrapper: styled('div', {
    background: '$backgroundPrimary',
    padding: '$6 0 0',

    '&:last-child': {
      marginBottom: '$4',
      padding: '$6 0',
    },
  }),

  Wrapper: styled(Flex, {
    position: 'relative',
    zIndex: 0,
  }),
};

export default styles;
